import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// Initialize only if connection string is configured (ensure .env has REACT_APP_APPINSIGHTS_CONNECTION_STRING)
const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING || 'InstrumentationKey=33e0e2f9-4b4a-4029-9046-d441e9881033;IngestionEndpoint=https://westus3-1.in.applicationinsights.azure.com/;LiveEndpoint=https://westus3.livediagnostics.monitor.azure.com/;ApplicationId=2345cbc6-6a99-4666-ac81-3b6adc27f222';

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: connectionString,
    // Enable distributed tracing across frontend & backend
    disableAjaxTracking: false,
    disableFetchTracking: false,
    enableCorsCorrelation: true,
    // Add backend domains to allow correlation headers. Adjust or remove domain boundaries as needed.
    correlationHeaderExcludedDomains: ['*.core.windows.net'],
    
    disableDependencyTracking: false,
    disableExceptionTracking: false, // Enable automatic unhandled exception tracking
    autoTrackPageVisitTime: false,
    enableAutoRouteTracking: false,
  }
});

let isInitialized = false;

export const initializeTelemetry = () => {
  if (connectionString && !isInitialized) {
    appInsights.loadAppInsights();
    
    // Capture explicit device, browser, and basic location (timezone) data
    const telemetryContext = {
      userAgent: navigator.userAgent,
      language: navigator.language,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      screenResolution: `${window.innerWidth}x${window.innerHeight}`,
      referrer: document.referrer || 'Direct/Bookmark'
    };

    // Track standard page view
    appInsights.trackPageView({ 
      name: 'Home',
      properties: telemetryContext
    });

    // Send an explicit "App Opened" event so it shows up in the same event stream as interactions
    appInsights.trackEvent({ 
      name: 'App Opened' 
    }, telemetryContext);

    isInitialized = true;
  }
};

export const trackInteraction = (actionName, properties = {}) => {
  if (isInitialized) {
    appInsights.trackEvent({ name: actionName }, properties);
  }
};

export const trackFailure = (flowName, error = null, additionalProperties = {}) => {
  if (isInitialized) {
    // Log the actual error to capture stack traces and error messages
    const exceptionToTrack = error instanceof Error ? error : new Error(error ? (error.message || String(error)) : `Flow Failed: ${flowName}`);
    
    appInsights.trackException({
      exception: exceptionToTrack,
      properties: { 
        flow: flowName,
        errorMessage: error ? (error.message || String(error)) : undefined,
        ...additionalProperties
      }
    });
  }
};
